module.exports = __webpack_public_path__ + "img/pr-8.a196c36a.png";